var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenNewTabIcon = function SvgOpenNewTabIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M18.438 1h-6a.555.555 0 0 0-.518.353.555.555 0 0 0 .12.607l2.46 2.423-7.087 6.974a.75.75 0 0 0 .243 1.224.75.75 0 0 0 .814-.151l7.11-6.997 2.467 2.43a.55.55 0 0 0 .616.12.555.555 0 0 0 .337-.518V1.563A.57.57 0 0 0 18.437 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M14.875 8.965a.75.75 0 0 0-.75.75V17.5H2.5V5.875h7.777a.75.75 0 1 0 0-1.5H2.404A1.4 1.4 0 0 0 1 5.777V17.59A1.41 1.41 0 0 0 2.403 19h11.812a1.41 1.41 0 0 0 1.41-1.41V9.715a.75.75 0 0 0-.75-.75"
  })));
};
export { SvgOpenNewTabIcon as ReactComponent };